import './quiz';

/* ============================================================
   Лендінг адвоката Приходька — логіка форм і дрібна поведінка.
   Ліди: console + localStorage. Бекенд підключається одним рядком
   перед підключенням цього файлу:
       <script>window.LEAD_ENDPOINT = 'https://…';</script>
   ============================================================ */
(function () {
  'use strict';

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];
  function isUtmMacro(v) { return /^\{.*\}$/.test(v || ''); } // нерозгорнутий макрос {keyword}

  (function captureUtm() {
    var qs = new URLSearchParams(location.search);
    UTM_KEYS.forEach(function (k) {
      var v = qs.get(k);
      if (v && !isUtmMacro(v) && v.length <= 300) {
        try { localStorage.setItem(k, String(v)); } catch (e) { }
      }
    });
  })();

  function readUtm() {
    var out = {};
    UTM_KEYS.forEach(function (k) {
      var v;
      try { v = localStorage.getItem(k); } catch (e) { v = null; }
      if (v) { out[k] = v; }
    });
    return out;
  }

  /* ---------- email-підказки з історії ---------- */
  var EMAILS_KEY = 'pa_emails';
  function knownEmails() {
    try { return JSON.parse(localStorage.getItem(EMAILS_KEY) || '[]'); } catch (e) { return []; }
  }
  function fillDatalist() {
    var dl = document.getElementById('lfEmails');
    if (!dl) return;
    dl.innerHTML = '';
    knownEmails().forEach(function (e) {
      var o = document.createElement('option');
      o.value = e;
      dl.appendChild(o);
    });
  }
  function rememberEmail(email) {
    if (!email) return;
    try {
      var arr = knownEmails().filter(function (e) { return e !== email; });
      arr.unshift(email);
      localStorage.setItem(EMAILS_KEY, JSON.stringify(arr.slice(0, 5)));
    } catch (e) { }
    fillDatalist();
  }
  fillDatalist();

  /* ---------- телефон: маска + вибір коду країни ---------- */
  function groupsOf(input) {
    var g = (input.getAttribute('data-groups') || '').trim();
    return g ? g.split(',').map(Number) : [];
  }
  function maxDigits(input) { return parseInt(input.getAttribute('data-max'), 10) || 15; }

  function formatDigits(digits, groups) {
    if (!groups.length) return digits;
    var out = [], i = 0;
    for (var k = 0; k < groups.length && i < digits.length; k++) {
      out.push(digits.slice(i, i + groups[k]));
      i += groups[k];
    }
    if (i < digits.length) out.push(digits.slice(i));
    return out.filter(Boolean).join(' ');
  }
  function placeholderFor(groups) {
    if (!groups.length) return '________';
    return groups.map(function (n) { return new Array(n + 1).join('_'); }).join(' ') + ' *';
  }

  /* Люди часто вводять номер із ведучим нулем (0 50 …) — для кодів,
     де національний номер без нуля, прибираємо його автоматично. */
  function stripTrunkZero(digits, form) {
    var ccEl = form && form.querySelector('.js-lf-cc-code');
    var cc = ccEl ? ccEl.textContent.trim() : '';
    if ((cc === '+380' || cc === '+48') && digits.charAt(0) === '0') return digits.replace(/^0+/, '');
    return digits;
  }

  document.querySelectorAll('.js-lf-phone').forEach(function (input) {
    input.addEventListener('input', function () {
      var digits = (input.value.match(/\d/g) || []).join('');
      digits = stripTrunkZero(digits, input.form).slice(0, maxDigits(input));
      input.value = formatDigits(digits, groupsOf(input));
      input.classList.remove('is-bad');
      clearErr(input.form, 'phone');
    });
    input.addEventListener('keypress', function (e) {
      if (e.key && e.key.length === 1 && !/\d/.test(e.key)) e.preventDefault();
    });
  });

  document.querySelectorAll('.js-lf-cc').forEach(function (cc) {
    var btn = cc.querySelector('.js-lf-cc-btn');
    var list = cc.querySelector('.js-lf-cc-list');
    var flag = cc.querySelector('.js-lf-cc-flag');
    var code = cc.querySelector('.js-lf-cc-code');
    var input = cc.closest('.lf-phone').querySelector('.js-lf-phone');

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var willOpen = list.hidden;
      document.querySelectorAll('.js-lf-cc-list').forEach(function (l) { l.hidden = true; });
      list.hidden = !willOpen;
      btn.setAttribute('aria-expanded', String(willOpen));
    });

    list.querySelectorAll('.lf-cc-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        code.textContent = opt.getAttribute('data-code');
        flag.src = opt.getAttribute('data-flag');
        input.setAttribute('data-max', opt.getAttribute('data-max'));
        input.setAttribute('data-groups', opt.getAttribute('data-groups'));
        var digits = (input.value.match(/\d/g) || []).join('').slice(0, maxDigits(input));
        input.value = formatDigits(digits, groupsOf(input));
        input.placeholder = placeholderFor(groupsOf(input));
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        input.focus();
      });
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.js-lf-cc-list').forEach(function (l) { l.hidden = true; });
  });

  /* ---------- валідація та відправлення ---------- */
  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v).trim()); }

  function setErr(form, field, msg) {
    if (!form) return;
    var input = form.querySelector('[name="' + field + '"]');
    var err = form.querySelector('.lf-err[data-for="' + field + '"]');
    if (input) input.classList.toggle('is-bad', !!msg);
    if (err) { err.textContent = msg || ''; err.classList.toggle('is-on', !!msg); }
  }
  function clearErr(form, field) { setErr(form, field, ''); }

  function submitLead(lead) {
    lead.lawyer = 'Андрій Анатолійович Приходько';
    lead.page = location.pathname;
    lead.ts = new Date().toISOString();
    console.info('[lead]', lead);
    try {
      var arr = JSON.parse(localStorage.getItem('pa_leads') || '[]');
      arr.push(lead);
      localStorage.setItem('pa_leads', JSON.stringify(arr));
    } catch (e) { }
    if (window.LEAD_ENDPOINT) {
      try {
        fetch(window.LEAD_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(lead),
          keepalive: true   /* переживає редірект на сторінку подяки */
        }).catch(function () { });
      } catch (e) { }
    }
    if (window.dataLayer) window.dataLayer.push({ event: 'generate_lead', lead_source: lead.source });
  }

  /* ---------- reCAPTCHA v3: якщо recaptchaSiteKey порожній — повний no-op ---------- */
  function getRecaptchaToken() {
    var cfg = window.LEAD_CONFIG || {};
    if (!cfg.recaptchaSiteKey || typeof window.grecaptcha === 'undefined') {
      return Promise.resolve('');
    }
    return new Promise(function (resolve) {
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(cfg.recaptchaSiteKey, { action: 'lead_submit' })
          .then(resolve)
          .catch(function () { resolve(''); });
      });
    });
  }

  function verifyRecaptcha(token) {
    var cfg = window.LEAD_CONFIG || {};
    if (!cfg.recaptchaSiteKey) return Promise.resolve(true);

    var body = new URLSearchParams({
      action: 'advokat_verify_recaptcha',
      nonce: cfg.recaptchaNonce || '',
      token: token
    });

    return fetch(cfg.recaptchaVerifyUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (result) { return !!(result && result.success); })
      .catch(function () { return false; });
  }

  document.querySelectorAll('.js-lead-form').forEach(function (form) {
    form.querySelectorAll('.lf-input').forEach(function (inp) {
      inp.addEventListener('input', function () { clearErr(form, inp.name); });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = form.querySelector('[name="name"]');
      var phone = form.querySelector('[name="phone"]');
      var email = form.querySelector('[name="email"]');
      var ccEl = form.querySelector('.js-lf-cc-code');
      var cc = ccEl ? ccEl.textContent.trim() : '+380';
      var digits = (phone.value.match(/\d/g) || []).join('');
      var need = maxDigits(phone);
      var ok = true;

      if (!name.value.trim() || name.value.trim().length < 2) {
        setErr(form, 'name', 'Вкажіть, будь ласка, імʼя'); ok = false;
      } else clearErr(form, 'name');

      if (!digits.length) {
        setErr(form, 'phone', 'Вкажіть номер телефону'); ok = false;
      } else if (cc === '+' ? digits.length < 7 : digits.length !== need) {
        setErr(form, 'phone', 'Номер має містити ' + (cc === '+' ? 'щонайменше 7' : need) + ' цифр'); ok = false;
      } else clearErr(form, 'phone');

      if (email && email.value.trim() && !isEmail(email.value)) {
        setErr(form, 'email', 'Перевірте, будь ласка, адресу email'); ok = false;
      } else if (email) clearErr(form, 'email');

      if (!ok) {
        var bad = form.querySelector('.lf-input.is-bad');
        if (bad) bad.focus();
        return;
      }

      /* Звʼязка для квіза кваліфікації на сторінці подяки: той самий id
         їде в ліді та лежить у sessionStorage — відповіді доповнюють
         саме цей лід, нового не створюється. */
      var leadRef = 'L-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
      try { sessionStorage.setItem('pa_lead_ref', leadRef); } catch (err) { }

      var submitBtn = form.querySelector('.js-submit') || form.querySelector('[type="submit"]');
      var submitLabelDefault = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; }

      getRecaptchaToken().then(function (token) {
        return verifyRecaptcha(token).then(function (recaptchaOk) {
          if (!recaptchaOk) { throw new Error('recaptcha_failed'); }

          var data = new FormData(form);
          var emailVal = String(data.get('email') || '').trim();
          submitLead(Object.assign({
            lead_ref: leadRef,
            source: form.id === 'heroLeadForm' ? 'hero' : 'main',
            name: String(data.get('name') || '').trim(),
            phone: cc + ' ' + phone.value.trim(),
            email: emailVal,
            topic: String(data.get('topic') || ''),
            comment: String(data.get('comment') || '').trim(),
            recaptcha_token: token || ''
          }, readUtm()));
          rememberEmail(emailVal);

          /* За ТЗ кваліфікації подяка — окрема сторінка з 4 питаннями. */
          location.href = (window.LEAD_CONFIG || {}).thanksUrl || 'thanks.html';
        });
      }).catch(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitLabelDefault; }
        setErr(form, 'phone', 'Не вдалося підтвердити, що ви не робот. Спробуйте ще раз.');
      });
    });
  });

  /* ---------- мобільна CTA-панель: показуємо, коли hero-форма пішла ---------- */
  var mcta = document.getElementById('mobileCta');
  var heroForm = document.getElementById('heroLeadForm');
  var leadSection = document.getElementById('lead');
  if (mcta && heroForm && 'IntersectionObserver' in window) {
    var heroVisible = true, leadVisible = false;
    function sync() { mcta.classList.toggle('is-on', !heroVisible && !leadVisible); }
    new IntersectionObserver(function (en) { heroVisible = en[0].isIntersecting; sync(); },
      { threshold: 0.15 }).observe(heroForm);
    if (leadSection) {
      new IntersectionObserver(function (en) { leadVisible = en[0].isIntersecting; sync(); },
        { threshold: 0.2 }).observe(leadSection);
    }
  }

  /* ---------- плавний скрол по якорях із урахуванням липкого хедера ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.pageYOffset - 74;
      window.scrollTo({ top: top, behavior: 'smooth' });
      /* фокус у першому полі, якщо ведемо до форми */
      if (id === '#lead') {
        setTimeout(function () {
          var f = document.querySelector('#mainLeadForm [name="name"]');
          if (f && window.matchMedia('(min-width: 700px)').matches) f.focus({ preventScroll: true });
        }, 600);
      }
    });
  });


  /* ---------- YouTube-фасад: ролик вантажиться лише після кліку ---------- */
  document.querySelectorAll('.js-video').forEach(function (el) {
    el.addEventListener('click', function () {
      var id = el.getAttribute('data-video');
      if (!id) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      f.title = 'Відео з адвокатом Андрієм Приходьком';
      f.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
      f.allowFullscreen = true;
      el.innerHTML = '';
      el.appendChild(f);
      el.classList.add('is-playing');
    }, { once: true });
  });

  /* ---------- Плаваюче відеозвернення: грає просто у вікні ---------- */
  (function () {
    var box = document.getElementById('vfloat');
    if (!box) return;

    var cfg = window.VIDEO_INTRO || {};
    var CLOSED_KEY = 'pa_vfloat_closed';
    var card = document.getElementById('vfloatCard');
    var playBtn = document.getElementById('vfloatPlay');
    var bar = document.getElementById('vfloatBar');
    var toggleBtn = document.getElementById('vfloatToggle');
    var muteBtn = document.getElementById('vfloatMute');
    var media = null;                 /* iframe (YouTube) або video (mp4) */
    var paused = false;
    var muted = false;

    function closedForever() {
      try { return sessionStorage.getItem(CLOSED_KEY) === '1'; } catch (e) { return false; }
    }

    /* поява: лише коли користувач прокрутив за перший екран,
       щоб картка не перекривала оффер і форму */
    var shown = false;
    function show() {
      if (shown || closedForever()) return;
      shown = true;
      box.hidden = false;
      void box.offsetWidth;           /* примусовий reflow: rAF не спрацьовує у фоновій вкладці */
      box.classList.add('is-on');
      window.removeEventListener('scroll', onScroll);
    }
    function threshold() {
      var hero = document.querySelector('.hero');
      return hero ? Math.max(320, hero.offsetHeight * 0.75) : 500;
    }
    function onScroll() { if (window.pageYOffset > threshold()) show(); }

    if (!closedForever()) {
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* Команди плеєру YouTube через postMessage (enablejsapi=1),
       щоб не тягнути окрему бібліотеку заради двох кнопок.
       До завантаження iframe команди губляться — тому чергуємо їх. */
    var ytReady = false;
    var ytQueue = [];
    function ytSend(func) {
      if (!media || media.tagName !== 'IFRAME' || !media.contentWindow) return;
      media.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: func, args: [] }), '*'
      );
    }
    function yt(func) {
      if (!ytReady) { ytQueue.push(func); return; }
      ytSend(func);
    }

    /* старт відтворення просто в картці — сторінку можна гортати далі */
    playBtn.addEventListener('click', function () {
      if (media) return;
      if (cfg.file) {
        media = document.createElement('video');
        media.src = cfg.file;
        media.autoplay = true;
        media.playsInline = true;
        if (cfg.poster) media.poster = cfg.poster;
      } else if (cfg.youtube) {
        media = document.createElement('iframe');
        /* controls=0 + modestbranding: рідний інтерфейс завеликий для картки */
        media.src = 'https://www.youtube-nocookie.com/embed/' + cfg.youtube +
          '?autoplay=1&rel=0&playsinline=1&controls=0&modestbranding=1&iv_load_policy=3&disablekb=1&fs=0&enablejsapi=1';
        media.title = 'Відеозвернення адвоката Андрія Приходька';
        media.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture';
        media.addEventListener('load', function () {
          ytReady = true;
          ytQueue.forEach(ytSend);
          ytQueue = [];
        });
      } else {
        return;
      }
      card.insertBefore(media, bar);
      card.classList.add('is-playing');
      bar.hidden = false;
      paused = false;
      muted = false;
      ytReady = false;
      ytQueue = [];
      bar.classList.remove('is-paused', 'is-muted');
    });

    toggleBtn.addEventListener('click', function () {
      if (!media) return;
      paused = !paused;
      if (media.tagName === 'VIDEO') { paused ? media.pause() : media.play(); }
      else { yt(paused ? 'pauseVideo' : 'playVideo'); }
      bar.classList.toggle('is-paused', paused);
      toggleBtn.setAttribute('aria-label', paused ? 'Відтворити' : 'Пауза');
    });

    muteBtn.addEventListener('click', function () {
      if (!media) return;
      muted = !muted;
      if (media.tagName === 'VIDEO') { media.muted = muted; }
      else { yt(muted ? 'mute' : 'unMute'); }
      bar.classList.toggle('is-muted', muted);
      muteBtn.setAttribute('aria-label', muted ? 'Увімкнути звук' : 'Вимкнути звук');
    });

    /* закриття: зупиняємо ролик і більше не показуємо в цьому візиті */
    document.getElementById('vfloatClose').addEventListener('click', function () {
      if (media) { media.remove(); media = null; }   /* прибирає звук разом з елементом */
      card.classList.remove('is-playing');
      bar.hidden = true;
      box.classList.remove('is-on');
      try { sessionStorage.setItem(CLOSED_KEY, '1'); } catch (e) { }
      setTimeout(function () { box.hidden = true; }, 320);
    });
  })();

  /* ---------- реальна висота хедера у CSS-змінну ---------- */
  var header = document.querySelector('header.site');
  function setHdr() {
    if (header) document.documentElement.style.setProperty('--hdr-h', header.offsetHeight + 'px');
  }
  setHdr();
  window.addEventListener('resize', setHdr);
  window.addEventListener('load', setHdr);
})();